import { ParseMapError } from "../../errors";

export const BETA_MAP_ID_RE = /^beta\/([a-z0-9]+(?:-[a-z0-9]+)*)$/;
export const BETA_MAP_SLUG_RE = /^[a-z0-9]+(?:-[a-z0-9]+)*$/;

export function isBetaMapId(mapId: string): boolean {
  return BETA_MAP_ID_RE.test(mapId);
}

export function isBetaMapSlug(slug: string): boolean {
  return BETA_MAP_SLUG_RE.test(slug);
}

export function betaSlugToMapId(slug: string): string {
  if (!isBetaMapSlug(slug)) {
    throw new ParseMapError(`Invalid beta map slug: ${slug}`);
  }
  return `beta/${slug}`;
}

export function betaMapIdToSlug(mapId: string): string {
  const match = BETA_MAP_ID_RE.exec(mapId);
  if (!match) {
    throw new ParseMapError(`Invalid beta mapId (expected beta/<slug>): ${mapId}`);
  }
  return match[1];
}

export function betaMapIdToS3Key(mapId: string): string {
  if (!isBetaMapId(mapId)) {
    throw new ParseMapError(`Invalid beta mapId (expected beta/<slug>): ${mapId}`);
  }
  return `${mapId}.json`;
}
